(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3624],{

/***/ 20435:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cariere",
      function () {
        return __webpack_require__(87424);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cariere; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./lib/careersContent.js
var careersContent = __webpack_require__(66618);
// EXTERNAL MODULE: ./node_modules/string.prototype.replaceall/index.js
var string_prototype_replaceall = __webpack_require__(97979);
var string_prototype_replaceall_default = /*#__PURE__*/__webpack_require__.n(string_prototype_replaceall);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(71604);
// EXTERNAL MODULE: ./components/Accordion/Item/index.js
var Item = __webpack_require__(4259);
// EXTERNAL MODULE: ./components/Accordion/Item/Header.js + 1 modules
var Header = __webpack_require__(85929);
// EXTERNAL MODULE: ./components/Accordion/Item/Body.js
var Body = __webpack_require__(66707);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./containers/Careers.js






















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteTitle = _publicRuntimeConfig.content.websiteTitle, _settings = _publicRuntimeConfig.settings, websiteName = _settings.websiteName, baseUrl = _settings.baseUrl, cdn = _settings.cdn;
var CareersContainer = function(param1) {
    var departmentsWithJobPositions = param1.departmentsWithJobPositions, addModal1 = param1.addModal, removeModal1 = param1.removeModal;
    var _acc;
    var asPath = (0,router.useRouter)().asPath;
    var ref5 = (0,react.useState)(""), openedSection = ref5[0], setOpenedSection = ref5[1];
    var ref1 = (0,react.useState)("Toate"), departmentFilter = ref1[0], setDepartmentFilter = ref1[1];
    var ref2 = (0,react.useState)("Toate"), cityFilter = ref2[0], setCityFilter = ref2[1];
    var ref3 = (0,react.useState)(null), selectedPosition = ref3[0], setSelectedPosition = ref3[1];
    var ref4 = (0,react.useState)(undefined), jobApplicationFormSubmitHandler = ref4[0], setJobApplicationFormSubmitHandler = ref4[1];
    var getPositionsCityNames = function() {
        return _toConsumableArray(new Set(departmentsWithJobPositions.map(function(department) {
            return department.jobs.map(function(job) {
                return job.locations && job.locations.map(function(location) {
                    return location.city;
                });
            });
        })// TODO: Replace with flat(2) if node >= 11 or new Babel version
        .reduce(function(acc, val) {
            return (_acc = acc).concat.apply(_acc, _toConsumableArray(val));
        }, []).sort()));
    };
    var getDepartmentNames = function() {
        return departmentsWithJobPositions.map(function(department) {
            return department.department_name;
        }).sort();
    };
    var filterDepartmentsByName = function(name, departments) {
        return departments.filter(function(department) {
            return department.department_name === name;
        });
    };
    var filterDepartmentsByCity = function(city, departments) {
        return departments.reduce(function(filteredDepartments, department) {
            var jobsInCity = department.jobs.filter(function(job) {
                return job.locations && job.locations.map(function(location) {
                    return location.city;
                }).includes(city);
            });
            return jobsInCity.length ? _toConsumableArray(filteredDepartments).concat([
                _objectSpread({}, department, {
                    jobs: jobsInCity
                }), 
            ]) : filteredDepartments;
        }, []);
    };
    var handleDepartmentFilterChange = function(event) {
        setDepartmentFilter(event.target.value);
    };
    var handleCityFilterChange = function(event) {
        setCityFilter(event.target.value);
    };
    var handleJobApplicationFormSubmit = function(values) {
        var lastName = values.lastName, firstName = values.firstName, phoneNumber = values.phoneNumber;
        var jobInfo = selectedPosition.jobInfo, location = selectedPosition.location;
        var emailSubject = encodeURIComponent("[".concat(location.city.toUpperCase(), "] [").concat(jobInfo.name.toUpperCase(), "] ").concat(values.firstName, " ").concat(values.lastName));
        var emailBody = encodeURIComponent("Buna ziua,\n\nInaintand acest e-mail veti reusi sa aplicati cu succes la postul vacant si va prezentam mai jos etapele procesului de recrutare:\n\n1. Depunerea documentelor de candidatură\n\nVă rugăm să transmiteți următoarele documente la adresa: recrutare@altex.ro\n\nCurriculum Vitae (CV);\n\nScrisoare de intenție;\n\nScrisori de recomandare de la doi foști angajatori – reprezintă un avantaj.\n\nEchipa noastră de Resurse Umane va evalua \xeendeplinirea condițiilor minime de experiență și competență, conform cerințelor specifice postului.\n\n2. Etapa de testare\n\n\xcen termen de 24 de ore de la trimiterea documentelor, vă rugăm să accesați și să completați testul disponibil la următorul link: https://forms.office.com/e/C6rUBLjQL4\n\n3. Interviul final\n\nCandidații care promovează etapa de testare vor fi contactați pentru a stabili un interviu final cu echipa de recrutare.\n\nDetaliile postului pentru care ați aplicat:\nPoziție: ".concat(jobInfo.name, "\n\nLocație: ").concat(location.city, "\n\nNume: ").concat(lastName, " ").concat(firstName, "\n\nTelefon: ").concat(phoneNumber, "\n\nConsimțăm\xe2nt pentru prelucrarea datelor:\nAcord pentru prelucrarea datelor cu caracter personal de către Altex: DA\n\nAcord pentru prelucrarea datelor cu caracter personal de către partenerii Altex: DA\n\nCu respect,\nEchipa Altex"));
        var mail = document.createElement("a");
        mail.style.display = "none";
        mail.href = "mailto:".concat(string_prototype_replaceall_default()(location.emails, "\\s+", ""), "?subject=").concat(emailSubject, "&body=").concat(emailBody);
        mail.target = "_blank";
        mail.click();
    };
    var handleSelectJobTitle = function(param) {
        var job = param.job, location = param.location;
        var jobInfo = _extends({}, job);
        setSelectedPosition({
            jobInfo: jobInfo,
            location: location
        });
        addModal1("jobApplication");
    };
    var handleCancelJobApplication = function() {
        setSelectedPosition(null);
        removeModal1("jobApplication");
    };
    var handleSubmitJobApplication = function() {
        jobApplicationFormSubmitHandler();
    };
    var onAccordionItemToggle = function(param) {
        var item = param.item, expanded = param.expanded;
        return history.replaceState({}, "", "#".concat(expanded ? item : ""));
    };
    var filteredDepartmentsByName = departmentFilter === "Toate" ? departmentsWithJobPositions : filterDepartmentsByName(departmentFilter, departmentsWithJobPositions);
    var filteredDepartmentsWithJobsByCity = cityFilter === "Toate" ? filteredDepartmentsByName : filterDepartmentsByCity(cityFilter, filteredDepartmentsByName);
    (0,react.useEffect)(function() {
        var hash = asPath.split("#")[1];
        if (hash) {
            var hashSlug = (0,helpers/* getSlug */.QF)(hash);
            var sectionElement = document.getElementById(hashSlug);
            if (sectionElement) {
                setOpenedSection(hashSlug);
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (openedSection) {
            var sectionElement = document.getElementById(openedSection);
            sectionElement.scrollIntoView();
        }
    }, [
        openedSection
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 99,
                        name: "Cariere - Locuri de munca ".concat(websiteTitle)
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h1",
                display: "h1",
                title: careersContent/* content */.k[websiteName].title,
                classesProp: "mt-6 font-normal text-[22px] md:text-[28px] leading-[28px] md:leading-[36px] w-full text-center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center w-full py-8 md:py-16 has-custom-start-on-bg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                    children: careersContent/* content */.k[websiteName].image.map(function(img) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: !img.isDefault ? /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                srcSet: img.path,
                                media: img.media
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "max-w-[714px]",
                                alt: "",
                                sizes: "100vw",
                                src: img.path
                            })
                        }, img.path);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-base leading-relaxed lg:w-3/4 mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-2 py-2 border-y mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            expandedItems: openedSection ? [
                                openedSection
                            ] : [],
                            onToggle: onAccordionItemToggle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                                id: "despre-noi",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            as: "h2",
                                            display: "h2",
                                            title: "Despre noi"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                        children: careersContent/* content */.k[websiteName].mainContent
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        display: "h2",
                        title: "Pozitii vacante",
                        classesProp: "mb-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex flex-wrap py-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "md:flex items-baseline md:mr-12 mb-4 md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "departmentFilter",
                                        className: "mr-3",
                                        children: "Departament"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        id: "departmentFilter",
                                        value: departmentFilter,
                                        onChange: handleDepartmentFilterChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "Toate",
                                                defaultValue: true,
                                                children: "Toate"
                                            }),
                                            getDepartmentNames().map(function(departmentName, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: departmentName,
                                                    children: departmentName
                                                }, "".concat(departmentName, "-").concat(i));
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "md:flex items-baseline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "cityFilter",
                                        className: "mr-3",
                                        children: "Oras"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        id: "cityFilter",
                                        value: cityFilter,
                                        onChange: handleCityFilterChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "Toate",
                                                children: "Toate"
                                            }),
                                            getPositionsCityNames().map(function(cityName) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: cityName,
                                                    children: cityName
                                                }, cityName);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    filteredDepartmentsWithJobsByCity.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            onToggle: onAccordionItemToggle,
                            expandedItems: openedSection ? [
                                openedSection
                            ] : [],
                            children: filteredDepartmentsWithJobsByCity.map(function(department) {
                                return department.jobs.map(function(job) {
                                    var ref7, ref6;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "border rounded px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                                            id: (0,helpers/* getSlug */.QF)(job.name),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col flex-shrink-0 md:flex-row md:items-center text-sm py-4 ".concat(cityFilter === "Toate" ? "pr-12" : ""),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: "flex-shrink-0 mb-3 md:mb-0 md:w-64 md:pr-6 font-medium capitalize",
                                                                children: job.name.toLowerCase()
                                                            }),
                                                            cityFilter === "Toate" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full mb-2 md:mb-0",
                                                                children: [
                                                                    "Pozitii deschise in:",
                                                                    " ",
                                                                    job.locations && job.locations.map(function(location) {
                                                                        return location.city;
                                                                    }).join(", ")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                                    children: job.content && Object.keys(job.content).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "py-4 md:py-8 border-gray-light border-t",
                                                        children: [
                                                            job.content.expectations && job.content.expectations.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                        as: "h3",
                                                                        display: "h4",
                                                                        title: "Candidatul ideal",
                                                                        classesProp: "text-red-brand mb-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "mb-4 text-sm",
                                                                        children: job.content.expectations.map(function(expectation, index) {
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                children: expectation
                                                                            }, index);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            job.content.other_specifications && job.content.other_specifications.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                        as: "h3",
                                                                        display: "h4",
                                                                        title: "Responsabilitati",
                                                                        classesProp: "text-red-brand mb-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "mb-4 text-sm",
                                                                        children: job.content.other_specifications.map(function(specification, index) {
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                children: specification
                                                                            }, index);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            job.content.benefits && job.content.benefits.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                        as: "h3",
                                                                        display: "h4",
                                                                        title: "Beneficii",
                                                                        classesProp: "text-red-brand mb-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "mb-4 text-sm",
                                                                        children: job.content.benefits.map(function(benefit, index) {
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                children: benefit
                                                                            }, index);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            ((ref7 = job.locations) === null || ref7 === void 0 ? void 0 : ref7.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                        as: "h3",
                                                                        display: "h4",
                                                                        title: "Alege orasul pentru care vrei sa aplici:",
                                                                        classesProp: "text-red-brand mb-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex flex-wrap",
                                                                        children: (ref6 = job.locations) === null || ref6 === void 0 ? void 0 : ref6.map(function(location, index) {
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                                className: "mr-2 mt-2",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                    title: location.city,
                                                                                    onClick: function() {
                                                                                        return handleSelectJobTitle({
                                                                                            job: job,
                                                                                            location: location
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }, index);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }, job.name);
                                });
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Nu exista pozitii vacante conform criteriilor selectate."
                    }),
                    careersContent/* content */.k[websiteName].footerContent
                ]
            }),
            selectedPosition && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                id: "jobApplication",
                header: "Aplica pentru pozitia ".concat(selectedPosition.jobInfo.name, " in ").concat(selectedPosition.location.city),
                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm mb-2",
                            children: "Te rugam sa atasezi CV-ul inainte de a trimite e-mail-ul."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: handleSubmitJobApplication,
                            title: "Adauga CV si aplica"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleCancelJobApplication,
                            className: "ml-4 outline-none underline text-red-brand",
                            children: "Renunta"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                    onSubmit: handleJobApplicationFormSubmit,
                    render: function(param) {
                        var handleSubmit = param.handleSubmit;
                        setJobApplicationFormSubmitHandler(function() {
                            return handleSubmit;
                        });
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit,
                            autoComplete: "false",
                            noValidate: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "md:flex md:flex-wrap md:-mx-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4 md:w-1/2 md:px-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                component: InputText/* default */.Z,
                                                id: "in_store_credit_request_last_name",
                                                name: "lastName",
                                                label: "Nume",
                                                type: "text",
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(60))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4 md:w-1/2 md:px-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                component: InputText/* default */.Z,
                                                id: "in_store_credit_request_first_name",
                                                name: "firstName",
                                                label: "Prenume",
                                                className: "Form-input Form-wide",
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(60))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4 md:w-1/2 md:px-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                name: "phoneNumber",
                                                component: InputText/* default */.Z,
                                                label: "Numar de telefon",
                                                type: "tel",
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                            name: "agree_personal_data_processing",
                                            component: Checkbox/* default */.Z,
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "Sunt de acord cu",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "text-red-brand",
                                                        target: "_blank",
                                                        href: "".concat(cdn, "/media/custom/upload/Nota_de_informare_privind_prelucrarea_datelor_personale_in_scop_de_recrutare.pdf"),
                                                        rel: "noreferrer",
                                                        children: "prelucrarea datelor"
                                                    }),
                                                    " ",
                                                    "mele personale de catre societatile din Grupul Altex in scopul recrutarii."
                                                ]
                                            }),
                                            type: "checkbox",
                                            required: true,
                                            validate: (0,validations/* isRequired */.q9)()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                "Pentru informatii suplimentare, va rugam sa accesati pagina",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(baseUrl, "/protectia-datelor-caracter-personal/pag/"),
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-red-brand",
                                                    children: "Protectia Datelor cu Caracter Personal"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }));
                    }
                })
            })
        ]
    }));
};
CareersContainer.propTypes = {
    departmentsWithJobPositions: prop_types_default().arrayOf((prop_types_default()).object).isRequired
};
/* harmony default export */ var Careers = ((0,es/* connect */.$j)(null, {
    addModal: actions/* addModal */.Y_,
    removeModal: actions/* removeModal */.a_
})(CareersContainer));

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./store/careers/actions.js + 1 modules
var careers_actions = __webpack_require__(86022);
;// CONCATENATED MODULE: ./pages/cariere/index.js








function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var cariere_ref = (0,config["default"])(), cariere_publicRuntimeConfig = cariere_ref.publicRuntimeConfig, cariere_websiteTitle = cariere_publicRuntimeConfig.content.websiteTitle;
var CareersPage = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(CareersPage, Component1);
    var _super = _createSuper(CareersPage);
    function CareersPage() {
        _classCallCheck(this, CareersPage);
        return _super.apply(this, arguments);
    }
    _createClass(CareersPage, [
        {
            key: "render",
            value: function render() {
                var departmentsWithJobPositions = this.props.departmentsWithJobPositions;
                if (departmentsWithJobPositions) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                        children: "Cariere - Locuri de munca ".concat(cariere_websiteTitle)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        name: "description",
                                        content: "Dezvolta-ti cariera cu ".concat(cariere_websiteTitle, "! Urmareste pozitiile vacante, afla noutatile si vino la interviu! Devino parte din echipa si beneficiezi de un pachet salarial atractiv, de invatare continua si de colegi pe masura! Hai sa descoperim impreuna cum putem creste!")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        name: "keywords",
                                        content: "locuri de munca, dezvoltare cariera, job-uri, joburi, pozitii vacante, oportunitati cariera"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Careers, {
                                departmentsWithJobPositions: departmentsWithJobPositions
                            })
                        ]
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                    children: "Pagina de cariere este momentan indisponibila."
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(ctx) {
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    var reduxStore, departmentsWithJobPositions;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                reduxStore = ctx.reduxStore;
                                _ctx.next = 3;
                                return reduxStore.dispatch((0,careers_actions/* getCareers */.R)());
                            case 3:
                                departmentsWithJobPositions = _ctx.sent;
                                return _ctx.abrupt("return", {
                                    departmentsWithJobPositions: departmentsWithJobPositions
                                });
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return CareersPage;
}(react.Component);
CareersPage.pageLayout = "default";
/* harmony default export */ var cariere = (CareersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4109,9774,2888,179], function() { return __webpack_exec__(20435); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);